import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=4d572cdc&"
import script from "./FeedbackForm.vue?vue&type=script&lang=js&"
export * from "./FeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d572cdc')) {
      api.createRecord('4d572cdc', component.options)
    } else {
      api.reload('4d572cdc', component.options)
    }
    module.hot.accept("./FeedbackForm.vue?vue&type=template&id=4d572cdc&", function () {
      api.rerender('4d572cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/FeedbackForm.vue"
export default component.exports